<template>
	<section :id="['container-' + index + '-' + videoData.type]" :class="['container-' + videoData.type]">
		<div class="container-lg">
			<div class="row">
                <div class="col-md-12">
                    <h2 v-if="videoData.config.title">{{ videoData.config.title }}</h2>
                </div>
                <div class="col-md-12">
                    <div class="row video-wrapper">
                        <iframe :src="videoData.config.videoUrl[0].url" height="100%" frameborder="0" allowfullscreen></iframe>
                    </div>
                </div>
			</div>
		</div>
        <hr class="horizontal-line">
	</section>
</template>

<script>

export default {
	props: {
		videoData: {
			type: Object
		},
		index: {
			type: Number
		},
	},
};

</script>

<style lang="scss" scoped>
@import "@/assets/scss/design-turin/videoComponent.scss";
</style>;